export const getSelectedRows = (index: number) => (prev: number[]) => {
    const oldIndex = prev.findIndex(value => value === index);
    if (oldIndex !== -1) {
        return [...prev.slice(0, oldIndex), ...prev.slice(oldIndex + 1)];
    }
    return [...prev, index];
};
